<template>
  <section class="f-62">
    <div class="alive_content" v-bg bg-url="@/v2/auto/assets/image/62/bg.png">
      <div class="title f-center-title">无限可能，AI 广场等你探索</div>
      <m-img
        class="f-select-center img"
        src="@/v2/auto/assets/image/62/14.png"
      />
    </div>
    <div
      class="alive_content"
      ref="aliveSlogan"
      v-bg
      bg-url="@/v2/auto/assets/image/62/bg.png"
      id="newborn"
    >
      <Slogan class="slogan" ref="slogan" />
    </div>
  </section>
</template>

<script>
import Slogan from '@/v2/auto/assets/image/62/slogan.vue'
import { resizeHandle } from '@/v2/auto/bus_key'
export default {
  name: 'Assistant',
  components: {
    Slogan,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    this.initHeight()
    this.$event.on(resizeHandle, () => {
      this.initHeight()
    })
  },
  methods: {
    initHeight() {
      if (isPad) {
        this.$gsap.set([this.$refs.slogan], {
          height: `${window.innerHeight}px`,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.f-62 {
  position: sticky;
  z-index: 79;
  width: 100%;
  overflow: hidden;
  margin-top: -5px;
  margin-bottom: calc(100vh + 200px);
  background-color: #000;
}

.alive_content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  .slogan {
    width: 600px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .img {
    height: auto;
  }
  .title {
    font-weight: 700;
    text-align: center;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    margin-bottom: 50px;
  }
}
</style>
